module.exports = __webpack_public_path__ + "files/SPIADI2019 - Présentation SFAV.82800da47368ccb72804d38b1808e108.pdf";